import React, { Component } from 'react'
import styled from 'styled-components'

import Modal from 'components/Modal'
import Select from 'components/Select'
import ArrowIcon from 'components/Svg/arrow.svg'
import { Input } from '@ubiwherenpm/adene-ui-components'

export default class EquipmentsEditModal extends Component {
  constructor () {
    super()
    this.state = {
      equipment: null
    }
  }

  componentWillMount () {
    const { equipment } = this.props
    this.setState({ equipment })
  }

  /**
   * Renders Edit modal buttons
   */
  renderEditButtons = [
    {
      label: 'cancelar',
      primary: false,
      click: () => this.props.toggle(false)
    },
    {
      label: 'guardar',
      primary: true,
      click: () => this.props.saveEquipment(this.state.equipment)
    }
  ]

  setNewEquipmentClass = (classe) => {
    const { equipment } = this.state
    equipment.selectedClass = Object.assign(classe)

    this.setState({ equipment })
  }

  setNewEquipmentQuantity = (quantity) => {
    const { equipment } = this.state
    equipment.quantity = Number(quantity)
    this.setState({ equipment })
  }

  render () {
    let { toggle, energyClasses } = this.props
    const { equipment } = this.state

    energyClasses = energyClasses
      .sort((a, b) => {
        var nameA = a.label.toUpperCase()
        var nameB = b.label.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        return 0
      })
      .sort((a, b) => {
        let plusA = a.label.substring(1, a.label.length)
        let plusB = b.label.substring(1, b.label.length)

        if (plusA > plusB) {
          return -1
        }

        if (plusA < plusB) {
          return 1
        }

        return 0
      })

    return (
      <Modal
        title={equipment.name}
        toggle
        buttons={this.renderEditButtons}
        onClick={() => toggle(false)}
      >
        <EditForm>
          {energyClasses && energyClasses.length > 1 &&
          <InputBox>
            <Label>Classe energética</Label>
            <StyledSelect
              margin
              placeholder={`Classe Energetica`}
              items={energyClasses}
              onChange={(value) => this.setNewEquipmentClass(value)}
              selected={equipment.selectedClass &&
                equipment.selectedClass.id
              }
              arrowIcon={ArrowIcon}
            />
          </InputBox>
          }
          <InputBox>
            <Label>Quantidade</Label>
            <NumberInput
              type={`number`}
              value={equipment.quantity}
              onChange={(e) => this.setNewEquipmentQuantity(e.target.value)}
            />
          </InputBox>
        </EditForm>
      </Modal>
    )
  }
}

const InputBox = styled.div`
  display: block;
  margin-bottom: 20px;
`

const NumberInput = styled(Input)`
  display: block;
  width: 100%;
  color: #010101;
  border: 1px solid #BABABA;
`

const StyledSelect = styled(Select)`
width: 100%;
max-width: initial;
text-align: left;

> div {
  border: 1px solid #BABABA;
  color: #3E3e3e;
}

img {
  object-fit: scale-down;
}
${({margin}) => margin && `margin-right: 30px;`}
`

const Label = styled.label`
text-align:left;
padding-bottom: 5px;
display: block;
width: 100%;
font-weight: bold;
text-transform: uppercase;
font-size: 12px;
`

const EditForm = styled.div`
padding: 20px;
width: 100%;
`



// WEBPACK FOOTER //
// ./src/containers/EquipmentsEditModal/index.js